import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10 bg-[#0b2128]">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[2fr_1fr_1fr] lg:px-8">
        <div className="space-y-4">
          <Logo small />
          <p className="max-w-sm text-sm text-slate-400">100% free to list, free to buy. Buyers pay the seller directly at pick-up — ISoldIt never holds your money. Proudly starting in Queensland.</p>
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-bold text-white">Marketplace</p>
          <Link data-testid="footer-browse-link" to="/browse" className="block text-slate-400 hover:text-[#d4f253]">Browse items</Link>
          <Link data-testid="footer-sell-link" to="/sell" className="block text-slate-400 hover:text-[#d4f253]">Sell an item</Link>
        </div>
        <div className="space-y-3 text-sm">
          <p className="font-bold text-white">Trust</p>
          <Link data-testid="footer-safety-link" to="/safety" className="block text-slate-400 hover:text-[#d4f253]">Safety tips</Link>
          <Link data-testid="footer-terms-link" to="/terms" className="block text-slate-400 hover:text-[#d4f253]">Terms &amp; Conditions</Link>
          <Link data-testid="footer-disclaimer-link" to="/disclaimer" className="block text-slate-400 hover:text-[#d4f253]">Disclaimer</Link>
          <Link data-testid="footer-privacy-link" to="/privacy" className="block text-slate-400 hover:text-[#d4f253]">Privacy Policy</Link>
          <Link data-testid="footer-contact-link" to="/contact" className="block text-slate-400 hover:text-[#d4f253]">Contact us</Link>
          <p className="text-slate-500">isoldit.com.au</p>
        </div>
      </div>
      <p className="border-t border-white/5 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} ISoldIt Australia. Pay on pick-up. Always. · <Link to="/terms" className="hover:text-[#d4f253]">Terms</Link> · <Link to="/disclaimer" className="hover:text-[#d4f253]">Disclaimer</Link> · <Link to="/privacy" className="hover:text-[#d4f253]">Privacy</Link></p>
    </footer>
  );
}
